<template>
  <div class="wire vpc d-flex" :class="{wire: true, vpc: true, 'd-flex': true, 'rightBorder': accountVisible}">
    <div class="text-center">
      <tooltip v-if="tooltipShow">
        <template slot="title">{{ $t('cloudenv.text_102') }}</template>
        <template slot="content">
          <p>{{ $t('common.name') }}：{{ brandName }}</p>
          <p>{{ $t('system.cpu_count')}}: {{ dataSource.cpu_count || '-' }}</p>
          <p>{{ $t('system.vcpu_count')}}: {{ dataSource.vcpu_count || '-' }}</p>
          <p>{{ $t('system.mem_size') }}：{{ sizestr(dataSource.mem_size, 'M', 1024) }}</p>
          <p>{{ $t('system.vmem_size') }}：{{ sizestr(dataSource.vmem_size, 'M', 1024) }}</p>
          <p>{{ $t('dashboard.text_136') }}：{{ dataSource.host_count }}</p>
          <p>{{ $t('cloudenv.text_72') }}：{{ dataSource.server_count }}</p>
          <p>{{ $t('compute.passthrough_device_count') }}：{{ dataSource.gpu_count }}</p>
          <p>{{ $t('system.gpu_used_count') }}：{{ dataSource.gpu_used_count }}</p>
        </template>
      </tooltip>
      <icon type="cloud" @click="handleClick" @mouseover="handleMouseover" @mouseout="handleMouseout" />
      <span class="name text-truncate" style="overflow: visible;"><div class="text">{{ brandName }}</div></span>
      <icon v-if="dataSource.accounts && dataSource.accounts.length && !accountVisible" class="expand-icon" @click="handleClick" type="expand" />
    </div>
    <span class="line" v-if="accountVisible" />
  </div>
</template>

<script>
import ResMixin from '@Network/sections/Topology/ResMixin'
import { sizestr } from '@/utils/utils'
import { getProductName } from '@/utils/auth'
import setting from '@/config/setting'
import Tooltip from './Tooltip'

export default {
  name: 'ResBrand',
  components: {
    Tooltip,
  },
  mixins: [ResMixin],
  props: {
    dataSource: {
      type: Object,
      default () {
        return {}
      },
    },
    accountVisible: Boolean,
  },
  data () {
    return {
      sizestr,
      tooltipShow: false,
    }
  },
  computed: {
    brandName () {
      const { companyInfo = {} } = this.$store.state.app
      const { name, name_en } = companyInfo
      if (name || name_en) {
        return setting.language === 'en' ? name_en : name
      }
      return getProductName()
    },
  },
  methods: {
    handleClick (e) {
      this.$emit('click')
    },
    handleMouseover () {
      this.tooltipShow = true
    },
    handleMouseout () {
      this.tooltipShow = false
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "@Network/sections/Topology/index.scss";
.expand-icon {
  position: absolute;
  left: 41px;
  top: 41px;
  width: 15px!important;
  height: 15px!important;
  border: none!important;
}
.rightBorder {
  border-right: 2px solid #000;
}
</style>
